import useCamera from "./stores/useCamera"
import useVue from "./stores/useVue"
import Keyboard from "./Keyboard.js"
import Appartementsvg from './svg/AppartmentSvg'
import Housesvg from './svg/Housesvg'
import Camerareset from './svg/Cameraresetsvg'
import Camerahaut from './svg/CameraHautsvg'
import Questionsvg from './svg/Questionsvg'




export default function Interface() {
    {/* ----------------------------- Set Camera mode ---------------------------- */ }
    const setCameraMode = useCamera((state) => state.setCameraMode)
    const setCameraPosition = (mode) => {
        setCameraMode(mode)
    }
    {/* -----------------------------Fin Set Camera mode ---------------------------- */ }



    {/* ----------------------------- Set Vue mode ---------------------------- */ }
    const setVueMode = useVue((state) => state.setVueMode)
    const setVue = (mode) => setVueMode(mode)

    const vueMode = useVue((state) => state.vueMode)
    {/* -----------------------------Fin Set Vue mode ---------------------------- */ }







    return <>
        {/* <div className="menu-wrapper">
            <div className="menu">
                <div className={`menu-list ${toggleMenuPrincipal ? 'active' : ''}`}>
                    <ul>
                        {vueMode === 'appartement' && <li onClick={setVue.bind(this, 'house')}>Voir l'immeuble</li>}
                        {vueMode === 'house' && <li onClick={setVue.bind(this, 'appartement')}>Voir l'appartement</li>}
                        <li onClick={setCameraPosition.bind(this, 'top')}>Vue de haut</li>
                        <li onClick={setCameraPosition.bind(this, 'init')}>Retour à la vue principale</li>
                    </ul>
                </div>
                <div className="menu-button"
                    onClick={handleToggleMenuPrincipal}>
                    <MenuSvg />
                </div>
            </div>
        </div> */}

        <div className="menu-wrapper">
            <div className="menu-button">
                <Questionsvg />
            </div>
            {vueMode === 'appartement' && <div className="menu-button" onClick={setCameraPosition.bind(this, 'top')}>
                <Camerahaut />
            </div>}
            {vueMode === 'appartement' && <div className="menu-button" onClick={setCameraPosition.bind(this, 'init')}>
                <Camerareset />
            </div>}
            {vueMode === 'house' && <div className="menu-button" onClick={setVue.bind(this, 'appartement')}>
                <Appartementsvg />
            </div>}
            {vueMode === 'appartement' && <div className="menu-button" onClick={setVue.bind(this, 'house')}>
                <Housesvg />
            </div>}

        </div>
        <Keyboard />
    </>

}